export default __webpack_public_path__ + "static/media/logo_ext.e789ac2f.png";